import { render } from "./galleryPage.vue?vue&type=template&id=1a709d56"
import script from "./galleryPage.vue?vue&type=script&lang=js"
export * from "./galleryPage.vue?vue&type=script&lang=js"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__